export default __webpack_public_path__ + "static/media/image-26.40aabd70.webp";